export default "__VITE_ASSET__BYHUnZRD__"